 /* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Mixins, Watch} from 'vue-property-decorator'
import {
    setMarketClue,
    duplicateCheck,
    getMarketClueById,
    setMarketClueById,
    getMarketChannelType,
    getMarketChannelNameByTypeId,
    getMarketCooperationPrevLevel, getMarketHighSchoolBranchCenterList, getSchoolList, setSchool,
    getUserList
} from '@/api/common'
import data from './data'
import {UserModule} from '@/store/modules/user'
 import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
 import CommonData from "@/utils/commonData";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewClue extends Mixins(data) {
    // ------ 变量 ------
    sourceId = ''
    sourceList = [
        {name: '合作伙伴', val: '0'},
        {name: '线上市场', val: '1'},
        {name: '其它', val: '2'},
        {name: '高校', val: '3'},
        {name: '分管', val: '4'},
    ]
    cooperativePartnerList: { name: string; id: number }[] = [] // 合作伙伴列表
    collegesList: { name: string; id: number }[] = [] // 高校列表
    branchedPassageList: { name: string; id: number }[] = [] // 分管列表
    gradeList = CommonData.gradeList
    sourceChildList: any[] = []
    wechat = '' // 学生微信ID
    phone = '' // 手机号
    other = '' // 其他联系方式
    remark = '' // 备注
    identity = '' // 身份
    region = '' // 地域
    regionName = '' // 当地域选择为【其他】的时候 使用
    keyword = '' // 关键字
    filterWord = '' // 搜索词
    consultingPage = '' // 咨询页面
    direction = '' // 咨询专业方向 --- 下拉
    directionInput = '' // 咨询专业方向 --- 输入框
    // directionList = ['理工科', '传媒艺术电影', '人文社科', '金融商科', '计算机', '其他']
    directionList = []
    eduTemandOptions = CommonData.eduTemandOptions
    // eduTemandValue: string[] = [] // 升学需求

    degree = '' // 意向度
    status = 1 // 是否下发
    degreeList = ['高', '中', '低']
    time = new Date() // 创建时间
    directorUserId = '' // 负责人ID
    repeatDetailShow = false //  重复的数据
    repeatDetailTable = [] // 重复弹框是否显示
    repeatName = false // 名字重复
    repeatWechat = false // 微信号重复
    repeatPhone = false // 手机号重复
    newBtnDisabled = false
    marketClueId = 0
    createName = ''
    elCascaderInput = false
    editMaketClueStatus = ''

    cascaderProps = {
        value: 'id',
        label: 'name',
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: this.cascaderLazyload
    }
    // saveBtn = true
    marketLevelPage = 1
    marketLevelSize = 20
    // marketLevelTotal = 0
    cooperativePartnerName = ''
    marketLevelloading = false
    sourceNameId = null
    repeatDetailTable1 = []
    repeatDetailTable2 = []
    repeatDetailTable3 = []
    formRules = {
        clueName: [{ required: true, message: '请填写线索名称', trigger: 'blur' }],
        sourceType: [{ required: true, message: '请选择来源', trigger: 'change' }],
        sourceName: [{ required: true, message: '请选择具体来源名称', trigger: 'blur' }],
        receiverUserId: [{ required: true, message: '请选择下发对接人', trigger: 'change' }],
        grade: [{ required: true, message: '请选择学生年级', trigger: 'change' }],
        eduTemandValue: [{ required: true, message: '请选择升学需求', trigger: 'change' }],
        isQuote: [{ required: true, message: '请选择是否报价', trigger: 'change' }],
        // attendSchool: [{ required: true, message: '请选择就读学校', trigger: ['change','blur'] }], 2024-3-5改成非必填
        isFromPractice: [{ required: true, message: '请选择是否实习/就业产品引流', trigger: 'change' }],
        direction: [{ required: true, message: '请选择咨询专业方向', trigger: 'change' }],
        equipment: [{ required: true, validator: this.equipmentValidator, trigger: 'change' }],
    }

    equipmentValidator(rule: any, value: string, callback: any) {
        if (this.formModel.isFromPractice === '1' && !value) {
            callback(new Error('请选择产品需求'))
        } else {
            callback()
        }
    }
    formModel = {
        clueName: '', // 线索名称
        sourceType: '', // 来源
        sourceName: '', // 集体来源名称id
        receiverUserId: '', // 下发人ID
        grade : '', // 学生年级
        eduTemandValue : [], // 升学需求
        isQuote : '', // 是否报价
        attendSchool: '' ,// 就读学校
        schoolId: null , // 就读学校id
        isFromPractice: '', // 实习/就业产品引流
        receiverUserRealName:'',
        direction : '',
        equipment:  '', // 产品需求
    }
    sourceIdList: any = [] // 具体来源名称
    addDialog = false  //添加学校
    name = ''
    page = 1
    schoolList = []
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    pageSchool = 1
    directorUserName = ''//负责人
    directionOptions = CommonData.directionOptions
    directionFlag = false
    loading = false
    schoolLoading = false
    pasteClueVisible = false
    pasteClueText = ''
    
    // ------ 计算属性 ------
    get userName() {
        return UserModule.userName
    }

    get createName1() {
        return this.marketClueId === 0 ? UserModule.userName : this.createName
    }

    get userId() {
        return UserModule.userId
    }




    // ------ 生命周期 ------
    created() {
        if (this.$route.query.id) {
            this.marketClueId = Number(this.$route.query.id)
            this.editMaketClueStatus = this.$route.query.status as string
            this.getMarketClueById()
            this.elCascaderInput = true
        }
    }

    // ------ 方法 -------
    async getMarketClueById() {
        this.loading = true
        await getMarketClueById({ id: this.marketClueId }).then( async (data: any)=>{
            const { createUserRealName, createdAt, degree, direction, directorUserId, grade,isQuote, name,
                other, phone, receiverUserId, remark, source, sourceType, status, wechat,
                marketChannelId, eduTemandList, consultPage, equipment, identity, keyWord,
                region, searchWord,marketLevel1ChannelId,schoolId, attendSchool
                ,isFromPractice,receiverUserRealName,directorUserRealName} = data.marketClue
            this.formModel.schoolId = schoolId;
            this.formModel.attendSchool = attendSchool == null ? '' : attendSchool;
            this.createName = createUserRealName == null ? '' : createUserRealName
            this.time = createdAt == null ? '' : createdAt
            this.degree = degree == null ? '' : degree
            this.directorUserId = directorUserId == null ? '' : directorUserId
            this.formModel.grade = grade == null ? '' : grade
            this.formModel.isQuote = isQuote == null ? '' : isQuote
            // this.formModel.clueName = name == null ? '' : name
            this.formModel.clueName = name == null ? '' : name
            this.other = other == null ? '' : other
            this.phone = phone == null ? '' : phone
            // this.receiverUserId = receiverUserId == null ? '' : receiverUserId
            this.formModel.receiverUserId = receiverUserId == null ? '' : receiverUserId
            this.formModel.receiverUserRealName = receiverUserRealName == null ? '' : receiverUserRealName
            this.directorUserName = directorUserRealName == null ? '' : directorUserRealName
            this.remark = remark == null ? '' : remark
            // this.sourceName = source == null ? '' : source
            this.formModel.sourceName = source == null ? '' : source
            // this.sourceType = sourceType == null ? '' : String(sourceType)
            this.formModel.sourceType = sourceType == null ? '' : String(sourceType)
            this.sourceId = marketChannelId == null ? '' : marketChannelId;
            (this.status as any) = status === '是' ? 1 : 0
            this.wechat = wechat == null ? '' : wechat
            this.formModel.eduTemandValue = eduTemandList.length > 0 ? eduTemandList : []

            this.directionOptions.map((item: any) => {
                //  item.children 的每一项的value都不等于direction
                // 判断一个数组的每一项都不等于某个值
                if (item.children.every((item1: any) => item1.value !== direction)) {
                    this.direction = direction
                    this.directionFlag = true

                }

                item.children.map((item1: any) => {
                    if (item1.value === direction) {
                        this.directionFlag = false
                        this.$set(this.formModel, 'direction',  [item.value, direction])
                    }
                })
            })

            this.identity = identity
            this.keyword = keyWord
            this.filterWord = searchWord
            this.region = region
            this.formModel.equipment = equipment
            this.consultingPage = consultPage
            this.formModel.isFromPractice = isFromPractice === '是' ? '1' : '0'
            if (this.formModel.sourceType === '1') {
                const data1: any = await getMarketChannelType()
                this.sourceChildList = data1.marketChannelTypeList
            }
            if (this.formModel.sourceType === '0') {
                this.getMarketCooperationPrevLevel()
            }
            //    add 高校/分管
            if (this.formModel.sourceType === '3') {
                const data: any = await getMarketHighSchoolBranchCenterList('3')
                this.collegesList = data.marketHighSchoolBranchCenterList
            }
            if (this.formModel.sourceType === '4') {
                const data: any = await getMarketHighSchoolBranchCenterList('4')
                this.branchedPassageList = data.marketHighSchoolBranchCenterList
            }
            this.sourceIdList=[marketLevel1ChannelId]
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }
    async sourceChange() {

        // if (this.sourceType === '1') {
        if (this.formModel.sourceType === '1') {
            const data: any = await getMarketChannelType()
            this.sourceChildList = data.marketChannelTypeList
            // this.sourceName = ''
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '0') {
            this.getMarketCooperationPrevLevel()
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '2') {
            this.formModel.sourceName = ''
        }
        //    add 高校/分管
        if (this.formModel.sourceType === '3') {
            const data: any = await getMarketHighSchoolBranchCenterList('3')
            this.collegesList = data.marketHighSchoolBranchCenterList
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '4') {
            const data: any = await getMarketHighSchoolBranchCenterList('4')
            this.branchedPassageList = data.marketHighSchoolBranchCenterList
            this.formModel.sourceName = ''
        }

    }

    // async confirmSchool() {
    //     await setSchool({name: this.schoolName, types: this.schoolType})
    //     this.$message.success('新建学校成功')
    //     this.formModel.attendSchool = this.schoolName
    //     const result: any = await getSchoolList({page: this.pageSchool,  name: this.schoolName })
    //     const schoolItem = result.schoolList.filter(item => item.name === this.schoolName)[0]
    //     this.formModel.schoolId = schoolItem.id
    //     this.schoolList = result.schoolList
    //     this.schoolName = ''
    //     this.schoolType = ''
    //     this.addDialog = false
    // }

    async getSchoolList() {
        this.schoolLoading = true
        await getSchoolList({page: this.page, name: this.name}).then((data: any) => {
            this.schoolList = [...this.schoolList, ...data.schoolList]
            const result = []
            const obj = {}
            for (let i = 0; i < this.schoolList.length; i++) {
                if (!obj[this.schoolList[i].id]) {
                    result.push(this.schoolList[i]);
                    obj[this.schoolList[i].id] = true;
                }
            }
            this.schoolList = result
            this.schoolLoading = false
        }).catch(() => {
            this.schoolLoading = false
        })
    }
    loadmore() {
        this.page++
        this.getSchoolList();
    }
    async remoteMethod (query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getSchoolList({page: this.page,  name: query })
            this.schoolList = result.schoolList
        } else {
            //   this.schoolList = []
        }
    }
    async handleSchool(){
        this.schoolLoading = true
        if ((this.schoolList.length == 0 || !this.name) && !this.formModel.attendSchool) {
            this.name = null
            this.page = 1
            const result: any = await getSchoolList({page: this.page, name: this.name})
            this.schoolList = result.schoolList
            this.schoolLoading = false
        }
        if (this.formModel.attendSchool) {
            this.schoolList = []
            this.page = 1
            // const result: any = await getSchoolList({page: this.page,  name: this.name })
            const result: any = await getSchoolList({page: this.page, name: this.formModel.attendSchool})
            this.schoolList = result.schoolList
            this.schoolLoading = false
        }
    }
    // 选择学校
    changeSchool (val) {
        if(val) {
            this.formModel.attendSchool = val
            this.formModel.schoolId = this.schoolList.find(item=> item.name === this.formModel.attendSchool).id
        }
    }
    clearSchool() {
        this.formModel.schoolId = null
        this.formModel.attendSchool = ''
        this.name = null
        this.page = 1
        this.getSchoolList()
    }

    async cascaderLazyload(node: any, reslove: any) {
        this.sourceIdList = [node.value]
        this.sourceId = node.value
        this.formModel.sourceName = node.label
        if (node.level === 0) { reslove(); return }
        const data: any = await getMarketChannelNameByTypeId(node.value)
        let nodes: any[] = []
        nodes = data.marketChanneNamelList.map((item: any) => ({
            id: item.id,
            name: item.name,
            leaf: node.level >= 1
        }))
        reslove(nodes)
    }

    async newClue() {
        if(!this.formModel.direction){
            this.formModel.direction = this.direction
        }
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if (this.status == 1 && !this.formModel.receiverUserId) {
                //     this.$message.error('请选择下发对接人');
                //     return
                // }
                if (this.wechat === '' && this.phone === '' && this.other === '') {
                    this.$message.error('请将学生微信，手机号，其他联系方式中任一填写完整');
                    return
                }
                this.newBtnDisabled = true
                const obj = {
                    name: this.formModel.clueName,
                    sourceType: Number(this.formModel.sourceType),
                    source: this.formModel.sourceName,
                    wechat: this.wechat,
                    phone: this.phone,
                    other: this.other,
                    grade: this.formModel.grade,
                    isQuote: this.formModel.isQuote,
                    direction: (typeof this.formModel.direction === 'string') ? this.formModel.direction : this.formModel.direction[1],
                    remark: this.remark,
                    degree: this.degree,
                    directorUserId: this.directorUserId,
                    status: this.status,
                    receiverUserId: this.formModel.receiverUserId,
                    marketChannelId: this.sourceId,
                    eduTemandList: this.formModel.eduTemandValue,
                    identity: this.identity,
                    region: this.region === '其他' ? this.regionName : this.region,
                    equipment: this.formModel.equipment,
                    keyWord: this.keyword,
                    searchWord: this.filterWord,
                    consultPage: this.consultingPage,
                    attendSchool: this.formModel.attendSchool,
                    schoolId: this.formModel.schoolId,
                    isFromPractice: this.formModel.isFromPractice,
                }
                if (this.formModel.sourceType !== '1') {
                    delete obj.marketChannelId
                }
                // const arr = ['identity', 'region', 'equipment', 'keyWord', 'searchWord', 'consultPage']
                // arr.forEach(item => {
                //     if (!obj[item] || item.length === 0) delete obj[item]
                // })
                this.loading = true
                setMarketClue(delNullProperty(obj)).then(() => {
                    this.$message.success('新建线索成功，页面即将关闭')
                    this.loading = false
                    setTimeout(() => {
                        window.close()
                    }, 2000)
                }).catch(() => {
                    this.newBtnDisabled = false
                    this.loading = false
                })



            }
        })

    }
    handleRepeatDetail(type){
        this.repeatDetailShow = true
        if(type == '0'){
            this.repeatDetailTable = this.repeatDetailTable1
        }
        if(type == '1'){
            this.repeatDetailTable = this.repeatDetailTable2
        }
        if(type == '2'){
            this.repeatDetailTable = this.repeatDetailTable3
        }
    }s
    async duplicateCheck(types: number) {
        const obj: any = {
            types,
            values: '',
            // id: this.marketClueId === 0 ? '' : this.marketClueId
        }

        if (this.marketClueId !== 0) {
            obj['id'] = this.marketClueId
        }
        switch (types) {
            case 0:
                if (!this.formModel.clueName) return
                obj.values = this.formModel.clueName
                const data1: any = await duplicateCheck(obj)
                if (data1.result.length > 0) {
                    this.repeatDetailTable1 = data1.result
                    this.repeatName = true
                } else {
                    this.repeatName = false
                }
                break;
            case 1:
                if (!this.wechat) return
                obj.values = this.wechat
                const data2: any = await duplicateCheck(obj)
                if (data2.result.length > 0) {
                    this.repeatDetailTable2 = data2.result
                    this.repeatWechat = true
                } else {
                    this.repeatWechat = false
                }
                break;
            case 2:
                if (!this.phone) return
                obj.values = this.phone
                const data3: any = await duplicateCheck(obj)
                if (data3.result.length > 0) {
                    this.repeatDetailTable3 = data3.result
                    this.repeatPhone = true
                } else {
                    this.repeatPhone = false
                }
                break;
        }
        const data: any = await duplicateCheck(obj)
        // if(data.result.length > 0){
        //     this.saveBtn = false
        // }else if(data.result.length == 0){
        //     this.saveBtn = true
        // }

        if (data.result.length > 0) {
            this.repeatDetailTable = data.result
            return true
        } else {
            return false
        }
    }

    async setMarketClueById() {
        if(!this.formModel.direction){
            this.formModel.direction = this.direction
        }
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if (this.status == 1 && !this.formModel.receiverUserId) {
                //     this.$message.error('请选择下发对接人');
                //     return
                // }
                if (this.wechat === '' && this.phone === '' && this.other === '') {
                    this.$message.error('请将学生微信，手机号，其他联系方式中任一填写完整');
                    return
                }
                const obj = {
                    name: this.formModel.clueName,
                    sourceType: Number(this.formModel.sourceType),
                    source: this.formModel.sourceName,
                    wechat: this.wechat,
                    phone: this.phone,
                    other: this.other,
                    grade: this.formModel.grade,
                    isQuote: this.formModel.isQuote,
                    direction: (typeof this.formModel.direction === 'string') ? this.formModel.direction : this.formModel.direction[1],
                    remark: this.remark,
                    degree: this.degree,
                    directorUserId: this.directorUserId,
                    status: this.status,
                    receiverUserId: this.formModel.receiverUserId,
                    schoolId: this.formModel.schoolId,
                    attendSchool: this.formModel.attendSchool,
                    id: this.marketClueId,
                    marketChannelId: this.sourceId,
                    eduTemandList: this.formModel.eduTemandValue,
                    identity: this.identity,
                    region: this.region === '其他' ? this.regionName : this.region,
                    equipment: this.formModel.equipment,
                    keyWord: this.keyword,
                    searchWord: this.filterWord,
                    consultPage: this.consultingPage,
                    isFromPractice: this.formModel.isFromPractice,
                }
                if (this.formModel.sourceType !== '1') {
                    delete obj.marketChannelId
                }
                this.newBtnDisabled = true
                // if(!this.saveBtn){
                //     this.$message.error('存在重复，无法保存')
                //     this.newBtnDisabled = false
                //     return
                // }
                this.loading = true
                setMarketClueById(obj).then(res => {
                    this.$message.success('编辑线索成功')
                    this.loading = false
                    setTimeout(() => {
                        this.clickClose()
                    }, 1500)
                }).catch(() => {
                    this.newBtnDisabled = false
                    this.loading = false
                })
            }
        })
    }

    seeClue(row: any) {
        if(row.types ==='线索'){
            window.open(window.location.origin + this.$route.matched[0].path + '/marketSeeClue?id=' + row.id, '_blank')
        }else if(row.types ==='客户'){ // 客户
            window.open(window.location.origin + '/customer' + '/transfromCustomerEdit?id=' + row.id, '_blank')
        }
    }

    changeSourceName(val?: any) {
        const node = (this.$refs['cascader'] as HTMLFormElement).getCheckedNodes()[0]
        this.sourceId = node.value
        this.formModel.sourceName = node.label
    }

    clickClose() {
        window.close()
    }

    // 修改下发状态
    changeStatus(value: number) {
        if (value === 0) {
            this.formModel.receiverUserId = ''
        }
    }

    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(
            {
                page: this.marketLevelPage,
                name: this.cooperativePartnerName,
                limit: this.marketLevelSize
            }
        )
        this.cooperativePartnerList = [...this.cooperativePartnerList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.cooperativePartnerList.length; i++) {
            if (!obj[this.cooperativePartnerList[i].id]) {
                result.push(this.cooperativePartnerList[i]);
                obj[this.cooperativePartnerList[i].id] = true;
            }
        }
        this.cooperativePartnerList = result
    }



    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel({
                page: this.marketLevelPage,
                limit:this.marketLevelSize,
                name: query
            })
            this.cooperativePartnerList = result.marketCooperationList
        }
    }

    changeCooperativePartner(val) {
        if (val) {
            this.formModel.sourceName = val
            this.sourceNameId = this.cooperativePartnerList.find(item => item.name === val).id
        }
    }

    clearCooperativePartner() {
        this.cooperativePartnerList= []
        this.sourceNameId = null
        this.formModel.sourceName = ''
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }

    changeDirectorUserId(e){
        this.directorUserId = e.id
    }

    changeReceiverUserId(e){
        this.formModel.receiverUserId = e.id
    }

    changeDirection(val) {
        if (val.length == 0) {
            this.directionFlag = true
        }
    }

    changeIsFromPractice () {
        this.formModel.equipment = null
    }

    async pasteClue() {
        if (!this.pasteClueText.trim()) {
            this.$message.warning('请先粘贴内容')
            return
        }

        // 按行解析，支持多种格式：1、key：value  或  key：value
        const lines = this.pasteClueText.split(/\r?\n/).filter(line => line.trim())
        const parsed: Record<string, string> = {}
        lines.forEach(line => {
            const match = line.match(/(?:^\s*\d+[、.．]\s*)?(.+?)：\s*(.*)/)
            if (match) {
                parsed[match[1].trim()] = match[2].trim()
            }
        })

        // key 映射表：粘贴文本中的 key -> 表单字段
        const KEY_MAP: Record<string, string> = {
            '线索名称': 'clueName',
            '来源': 'sourceType',
            '具体来源名称': 'sourceName',
            '学生年级': 'grade',
            '咨询专业方向': 'direction',
            '升学需求': 'eduTemandValue',
            '是否报价': 'isQuote',
            '实习/就业产品引流': 'isFromPractice',
            '实习就业产品引流': 'isFromPractice',
            '下发对接人': 'receiverUserRealName',
        }

        // 来源名称 -> sourceType 值
        const SOURCE_TYPE_MAP: Record<string, string> = {
            '合作伙伴': '0',
            '线上市场': '1',
            '其它': '2',
            '高校': '3',
            '分管': '4',
        }

        // 需要重置/可能赋值的字段列表（匹配不上就保持空）
        const FORM_FIELDS_TO_RESET = [
            'clueName', 'sourceType', 'sourceName', 'grade', 'direction',
            'eduTemandValue', 'isQuote', 'isFromPractice', 'receiverUserId', 'receiverUserRealName',
        ]

        // 先把这些字段全部清空，匹配上什么再填什么
        FORM_FIELDS_TO_RESET.forEach(f => {
            const defaultValue: Record<string, any> = {
                eduTemandValue: [],
                direction: '',
            }
            this.$set(this.formModel, f, defaultValue[f] !== undefined ? defaultValue[f] : '')
        })

        const setValues: Record<string, any> = {}
        let receiverUserName = ''
        let pendingSourceName = ''

        Object.keys(parsed).forEach(key => {
            const formKey = KEY_MAP[key]
            if (!formKey) return
            const val = parsed[key]

            switch (formKey) {
                case 'sourceType':
                    // 来源名称转值（去掉括号里的固定等后缀），匹配不上则跳过
                    {
                        const sourceName = val.replace(/[（(].*?[）)]/g, '').trim()
                        const sourceVal = SOURCE_TYPE_MAP[sourceName]
                        if (sourceVal !== undefined) {
                            setValues.sourceType = sourceVal
                        }
                    }
                    break
                case 'isQuote':
                    // 是否报价：只识别 是/否
                    if (val === '是' || val === '否') {
                        setValues.isQuote = val === '是' ? '1' : '0'
                    }
                    break
                case 'isFromPractice':
                    // 只识别 是/否，其他不规范的跳过
                    if (val === '是' || val === '否') {
                        setValues.isFromPractice = val === '是' ? '1' : '0'
                    }
                    break
                case 'eduTemandValue':
                    // 升学需求：逗号分隔，每个值必须完全命中枚举
                    setValues.eduTemandValue = val.split(/[,，、]/)
                        .map(s => s.trim())
                        .filter(s => this.eduTemandOptions.includes(s))
                    break
                case 'grade':
                    // 学生年级：只按别名词库精确匹配，匹配不上则空
                    {
                        const found = CommonData.gradeMapping.find(item => item.aliases.includes(val))
                        if (found) {
                            setValues.grade = found.standard
                        }
                    }
                    break
                case 'sourceName':
                    // 具体来源名称：延迟到 sourceType 加载完数据后再校验
                    pendingSourceName = val
                    break
                case 'receiverUserRealName':
                    // 只存临时变量，查完用户再决定要不要赋值
                    receiverUserName = val
                    break
                case 'direction':
                    // 咨询专业方向：必须完全匹配 directionOptions 子项 value
                    {
                        let hit = false
                        for (const group of this.directionOptions) {
                            for (const child of group.children) {
                                if (child.value === val || child.label === val) {
                                    setValues.direction = [group.value, child.value]
                                    hit = true
                                    break
                                }
                            }
                            if (hit) break
                        }
                    }
                    break
                default:
                    // 其他字段（如 clueName）直接赋值
                    setValues[formKey] = val
            }
        })

        // 如果设置了来源，先加载对应的具体来源列表
        if (setValues.sourceType) {
            await this.loadSourceData(setValues.sourceType)
        }

        // 具体来源名称：根据来源类型从对应列表匹配，匹配不上则空
        if (pendingSourceName && setValues.sourceType) {
            const sourceType = setValues.sourceType
            if (sourceType === '1') {
                // 线上市场：级联选择，格式 "一级/二级"，如 "大搜/大搜-工业富联"
                const parts = pendingSourceName.split('/').map(s => s.trim())
                if (parts.length >= 2) {
                    const [level1Name, level2Name] = parts
                    const level1 = this.sourceChildList.find((item: any) => item.name === level1Name)
                    if (level1) {
                        try {
                            const data: any = await getMarketChannelNameByTypeId(level1.id)
                            const level2List = data.marketChanneNamelList || []
                            const level2 = level2List.find((item: any) => item.name === level2Name)
                            if (level2) {
                                setValues.sourceName = level2.name
                                this.sourceId = level2.id
                                this.sourceIdList = [level1.id, level2.id]
                            }
                        } catch (e) {
                            // 接口失败则不赋值
                        }
                    }
                }
            } else if (sourceType === '0' || sourceType === '3' || sourceType === '4') {
                // 合作伙伴 / 高校 / 分管：从已加载列表精确匹配 name
                let sourceList: { name: string }[] = []
                if (sourceType === '0') sourceList = this.cooperativePartnerList
                else if (sourceType === '3') sourceList = this.collegesList
                else if (sourceType === '4') sourceList = this.branchedPassageList
                const hit = sourceList.find((item: any) => item.name === pendingSourceName)
                if (hit) {
                    setValues.sourceName = hit.name
                }
            } else if (sourceType === '2') {
                // 其它：普通输入框，直接赋值
                setValues.sourceName = pendingSourceName
            }
        }

        // 处理下发对接人：带粘贴值当 name 参数搜索后端过滤，再精确匹配 id 或 realName，匹配不上则不赋值
        if (receiverUserName) {
            try {
                const data: any = await getUserList({ name: receiverUserName, page: 1, limit: 20 })
                const match = (data.userList || []).find((u: any) =>
                    u.id === receiverUserName || u.realName === receiverUserName
                )
                if (match) {
                    setValues.receiverUserId = match.id
                    setValues.receiverUserRealName = match.realName
                }
            } catch (e) {
                this.$message.error('查询用户失败，下发对接人已跳过')
            }
        }

        // 合并到 formModel
        this.formModel = {
            ...this.formModel,
            ...setValues,
        }

        this.pasteClueVisible = false
        this.pasteClueText = ''
        this.$message.success('粘贴解析成功')
    }

    // 根据 sourceType 加载对应的具体来源数据
    async loadSourceData(sourceType: string) {
        if (sourceType === '1') {
            const data: any = await getMarketChannelType()
            this.sourceChildList = data.marketChannelTypeList
        }
        if (sourceType === '0') {
            this.getMarketCooperationPrevLevel()
        }
        if (sourceType === '3') {
            const data: any = await getMarketHighSchoolBranchCenterList('3')
            this.collegesList = data.marketHighSchoolBranchCenterList
        }
        if (sourceType === '4') {
            const data: any = await getMarketHighSchoolBranchCenterList('4')
            this.branchedPassageList = data.marketHighSchoolBranchCenterList
        }
    }

    @Watch('userId')
    userIdChange() {
        this.directorUserId = this.userId
    }

    @Watch('userName')
    userNameChange(userName) {
        this.directorUserName = userName
    }
}
